import { LoadPageAction } from "../../../pillar/common/actions/LoadPageAction";
import { LoadPageByModulePayload } from "./LoadPageByModulePayload";

export function getQueryListByModuleType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Query List by Module of ${(type as any).$typeName}`;
}

export class QueryListByModuleAction<TModel> implements LoadPageAction {
  readonly identifier = new Date().getTime().toString();
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: LoadPageByModulePayload) {
    this.type = getQueryListByModuleType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/QueryListByModuleAction.ts